import { render, staticRenderFns } from "./render-installation-status-column-value.vue?vue&type=template&id=99d4e146"
import script from "./render-installation-status-column-value.vue?vue&type=script&lang=js"
export * from "./render-installation-status-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d4e146')) {
      api.createRecord('99d4e146', component.options)
    } else {
      api.reload('99d4e146', component.options)
    }
    module.hot.accept("./render-installation-status-column-value.vue?vue&type=template&id=99d4e146", function () {
      api.rerender('99d4e146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-installation-status-column-value.vue"
export default component.exports